import {Component, Input} from '@angular/core';

/**
 * navItem "Storno" of the Provisionszeile OBC, widget alias
 * `cp.provisionContract.cancellation`.
 *
 * The effective (shifted to the next month's first) `cancellationDate` and the
 * `cancellationReason`. Both stay empty on a slice that was never cancelled, and that empty state
 * is the truth — no FD-7(a) hint applies here.
 */
@Component({
    selector: 'cp-provision-contract-cancellation',
    templateUrl: './cp-provision-contract-cancellation.component.html',
    styleUrls: ['./cp-provision-contract-cancellation.component.scss'],
    standalone: false
})
export class CpProvisionContractCancellationComponent {

    @Input() provisionContractId: number;

    /** Fields per row — the side view passes 1. */
    @Input() columns: number = 2;

    readonly fields: string[] = [
        'cancellationDate',
        'cancellationReason'
    ];

}
